/**
 * ExtraResources Component
 * Extracted from KnowledgeBasePage.tsx to reduce file size
 */

import React from 'react';
import { Link } from 'react-router-dom';

export const ExtraResources: React.FC = () => {
  return (
    <>
      {/* Extra Resources Section */}
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="rounded-xl p-6" style={{ backgroundColor: 'rgba(217, 200, 142, 0.2)', border: '2px solid #D9C88E' }}>
          <h3 className="font-semibold text-lg mb-3 flex items-center gap-2" style={{ color: '#4A6651' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#D9C88E">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
            </svg>
            Quick Tips
          </h3>
          <p style={{ color: '#598D76' }}>
            New to DinnerBrain? Start by adding 5-10 of your favorite recipes, then create your first weekly meal plan. 
            The shopping list will automatically compile all ingredients!
          </p>
        </div>

        <div className="rounded-xl p-6" style={{ backgroundColor: 'rgba(106, 76, 147, 0.1)', border: '2px solid #6A4C93' }}>
          <h3 className="font-semibold text-lg mb-3 flex items-center gap-2" style={{ color: '#4A6651' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#6A4C93">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            Pro Features
          </h3>
          <p style={{ color: '#598D76' }}>
            Upgrade to Premium for unlimited recipes, PDF downloads, Alexa integration, and advanced macro tracking. 
            Perfect for serious meal planners!
          </p>
        </div>
      </div>

      {/* Need Help Section */}
      <div className="mt-12 rounded-xl p-8 text-center" style={{ 
        background: 'linear-gradient(135deg, #6E9C87 0%, #3C6E71 100%)'
      }}>
        <h2 className="text-2xl font-bold mb-4 text-white">Need More Help?</h2>
        <p className="text-white mb-6 opacity-95">Can&apos;t find what you&apos;re looking for? We&apos;ve got you covered!</p>
        <div className="flex flex-wrap gap-4 justify-center">
          <Link 
            to="/contact" 
            className="bg-white px-6 py-3 rounded-lg shadow hover:shadow-lg transition-all transform hover:-translate-y-1 font-semibold flex items-center gap-2"
            style={{ color: '#4A6651', minHeight: '44px' }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#E07A55">
              <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
            </svg>
            Contact Support
          </Link>
        </div>
      </div>
    </>
  );
};